import { render, staticRenderFns } from "./cateList.vue?vue&type=template&id=e6f00284&scoped=true&"
import script from "./cateList.vue?vue&type=script&lang=js&"
export * from "./cateList.vue?vue&type=script&lang=js&"
import style0 from "./cateList.vue?vue&type=style&index=0&id=e6f00284&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6f00284",
  null
  
)

export default component.exports